// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__okylG","homeTitle":"Home_homeTitle__7Xo0I","homeTitle2":"Home_homeTitle2__tN5Ad"};